import { connect } from 'react-redux'
import RiderProfilePane from '../../components/riders/riderdetails/RiderProfilePane'
import * as actions from '../../state/actions/riders'
import { IRiderObject, IStoreState } from '../../types'
import history from '../../history'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    riders: state.riders.items,
    loading: state.riders.isFetching
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderPersonalInfo: (riderId: string): any => {
      return dispatch(actions.getRiderPersonalInfo(riderId))
    },
    archive: async (rider: IRiderObject) => {
      await dispatch(actions.archiveRider(rider))
      history.push('/riders')
    },
    restore: async (rider: IRiderObject) => {
      await dispatch(actions.restoreArchiveRider(rider))
      history.push('/riders')
    },
    activate: (rider: IRiderObject) => {
      dispatch(actions.activateRider(rider))
      history.push('/riders')
    },
    deactivate: (rider: IRiderObject) => {
      dispatch(actions.deactivateRider(rider))
      history.push('/riders')
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderProfilePane)



// WEBPACK FOOTER //
// ./src/containers/riders/RiderProfilePane.ts